export const actualEvents = [
    {
        name: "CES",
        url: "https://www.ces.tech/",
        date: "January 06 - 09 2026"
    },
    {
        name: "Auto Shanghai",
        url: "",
        date: "April - May "
    },
    {
        name: "Deep Tech Momentum",
        url: "https://www.deeptech.build/",
        date: "May 20 - 21"
    },
    {
        name: "Startup Autobahn",
        url: "https://startup-autobahn.com/",
        date: "July 2"
    },
]

export const archivedEvents = [

    {
        name: "Slush",
        url: "https://slush.org/",
        date: "November 19 - 20 2025"
    },
    {
        name: "ELIV - International VDI Congress",
        url: "https://www.vdiconference.com/eliv/#",
        date: "October 15 - 16 2025"
    },
    {
        name: "HTVD",
        url: "https://www.hightech-venture-days.com/home/htvd-eu/",
        date: "October 14 - 15 2025"
    },
    {
        name: "Bits & Pretzels",
        url: "https://www.bitsandpretzels.com/",
        date: "September 20 - October 1st 2025"
    },
    {
        name: "MOVE America",
        url: "https://www.terrapinn.com/exhibition/move-america/index.stm",
        date: "September 24 - 25 2025"
    },
    {
        name: "IAA Mobility 2025",
        url: "https://www.iaa-mobility.com/en",
        date: "September 9 - 14 2025"
    },
    {
        name: "NewLab: New Mobility Futures",
        url: "https://lu.ma/mysk8m1o",
        date: "July 17 2025"
    },
    {
        name: "X-BA Call",
        url: null,
        date: "June 2025"
    },
    {
        name: 'TiECon',
        url: 'https://tiesv.ai/',
        date: 'May 2025',
    },
    {
        name: 'NOAH Conf. "Digital, Sustainable, and Profitable”',
        url: 'https://www.noah-conference.com/',
        date: 'May 3',
    },
    {
        name: 'DeepTech Momentum',
        url: 'https://www.deeptech.build/',
        date: 'May 15',
    },
    {
        name: 'Axis Innovation',
        url: 'https://www.axistelaviv.com/',
        date: 'May 22',
    },
    {
        name: "Vivatech Paris",
        url: "https://vivatechnology.com",
        date: "11-14 June"
    },

]
